// tslint:disable
/**
 * OrderWire API
 * The OrderWire API Documentation
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum OrderDiscountType {
    Comp = 'Comp',
    CustomDiscount = 'CustomDiscount',
    PredefinedDiscount = 'PredefinedDiscount',
    CalculatedLineOrderDiscount = 'CalculatedLineOrderDiscount',
    RedeemPoint = 'RedeemPoint',
}
